(function () {
  function bind(root) {
    if (!root || root.dataset.d1ShareBound === 'true') return;
    root.dataset.d1ShareBound = 'true';

    var url = root.getAttribute('data-share-url') || window.location.href;
    var title = root.getAttribute('data-share-title') || document.title;
    var nativeBtn = root.querySelector('[data-d1-share-native]');
    var copyBtn = root.querySelector('[data-d1-share-copy]');
    var copied = root.querySelector('[data-d1-share-copied]');

    if (nativeBtn && typeof navigator.share === 'function') {
      nativeBtn.hidden = false;
      nativeBtn.addEventListener('click', function () {
        navigator.share({ url: url, title: title }).catch(function () {});
      });
    }

    if (!copyBtn) return;
    copyBtn.addEventListener('click', function () {
      var done = function () {
        copyBtn.setAttribute('data-copied', 'true');
        if (copied) copied.hidden = false;
        window.setTimeout(function () {
          copyBtn.removeAttribute('data-copied');
          if (copied) copied.hidden = true;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy link', url);
        });
        return;
      }
      window.prompt('Copy link', url);
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-d1-share]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('product-info:loaded', bindAll);
})();
